import axiosInstance from "../Config/axiosConfig";

const getHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  const storedDeviceId = localStorage.getItem("deviceId");
  const storedUserIp = localStorage.getItem("userIp");

  return {
    Authorization: `Bearer ${accessToken}`,
    ...(storedDeviceId && { UserDevice: storedDeviceId }),
    ...(storedUserIp && { UserIPAddress: storedUserIp }),
  };
};

export const fetchInstructors = async () => {
  try {
    const response = await axiosInstance.get("/Admin/get-instructors", {
      headers: getHeaders(),
    });
    console.log(response.data)
    // Normalize the response data to always be an array
    let instructorsData = [];
    if (Array.isArray(response.data)) {
      instructorsData = response.data;
    } else if (response.data && Array.isArray(response.data.instructors)) {
      instructorsData = response.data.instructors;
    } else if (response.data && response.data.data) {
      instructorsData = Array.isArray(response.data.data) ? response.data.data : [response.data.data];
    } else {
      instructorsData = [response.data];
    }

    return instructorsData;
  } catch (error) {
    console.error("Error fetching instructors:", error);
    throw error;
  }
};

export const registerTeacher = async (teacherData) => {
  try {
    const formData = new FormData();
    formData.append('email', teacherData.email);
    formData.append('name', teacherData.name);
    formData.append('role', 3); // Role 3 for instructors
    formData.append('instructorTitle', teacherData.instructorTitle);
    formData.append('aboutInstructor', teacherData.aboutInstructor);
    
    teacherData.instructorTrainingEducationLevels.forEach(level => {
      formData.append('instructorTrainingEducationLevels', level);
    });
    
    if (teacherData.userPhotoFile && teacherData.userPhotoFile[0]) {
      formData.append('userPhotoFile', teacherData.userPhotoFile[0].originFileObj);
    }

    const response = await axiosInstance.post("/Admin/register-user", formData, {
      headers: {
        ...getHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error registering teacher:", error);
    throw error;
  }
};